import React from "react";
import { connect } from "react-redux";

import { withT } from "services/translation/";

import { Button, Form, Col, Card } from "react-bootstrap";

import ToggleButton from "components/Common/Buttons/Toggle";

import Icon from "components/Icons/Icon";

import Loading from "components/Loading";

import Alert from "components/Common/Alert";

import NameField from "./NameField";

import {
  requestChangeProfileStart,
  requestChangeProfileNotified,
  requestChangeMFAStart,
  requestChangeMFANotified,
} from "services/redux/actions/";

class UserDetailsForm extends React.Component {
  render() {
    const { user, t } = this.props;

    const profileLoading = user.actions.changeProfile.loading;
    const mfaLoading = user.actions.changeMFA ? user.actions.changeMFA.loading : false;

    if (user.actions.changeProfile.success === true) {
      Alert({
        text: t("user_details.profile_updated_successfully"),
        icon: "success"
      });
      // Reset success message
      this.props.dispatch(requestChangeProfileNotified());
    }

    if (user.actions.changeMFA && user.actions.changeMFA.success === true) {
      Alert({
        text: t("user_details.profile_updated_successfully"),
        icon: "success"
      });
      // Reset success message
      this.props.dispatch(requestChangeMFANotified());
    }

    return (
      <Form
        onSubmit={e => {
          e.preventDefault();
          const firstName = e.target.firstName.value;
          const lastName = e.target.lastName.value;
          const locale = user.language;
          const timezone = user.timezone;

          this.props.dispatch(
            requestChangeProfileStart({
              firstName,
              lastName,
              locale,
              timezone
            })
          );
        }}>
        <Form.Row>
          <NameField
            name="firstName"
            label={t("user_details.first_name")}
            defaultValue={user.firstName}
          />
          <NameField
            name="lastName"
            label={t("user_details.last_name")}
            defaultValue={user.lastName}
          />
        </Form.Row>

        <Form.Row>
          <Form.Group controlId="formGroupSave" as={Col} md="12" style={{marginBottom: "15px"}}>
            <Button
              variant="primary"
              type="submit"
              className="float-right"
              disabled={profileLoading ? 1 : 0}>
              {profileLoading ? <Loading /> : null} {t("user_details.save_changes")}
            </Button>
          </Form.Group>
        </Form.Row>

        { // 2FA section
          <div>
            <hr />
            <Form.Row className="pl-2 mt-4 d-flex align-items-center">
              <Card.Title>{t("user_details.two_factor_auth")}</Card.Title>
              <Button
                variant="primary"
                style={{
                  height: "19px",
                  width: "19px",
                  borderRadius: "50%",
                  padding: "0",
                  marginLeft: "15px",
                  marginBottom: "0.75rem"
                }}
                onClick={() => {
                  window.Intercom('showArticle', 12859172) 
                }}
              ><Icon 
                className="fas fa-question fa-xs"
                style={{
                  position: "relative",
                  bottom: "3px",
                }}
              /></Button>
            </Form.Row>
            <Form.Row className="pl-2">{t("user_details.two_factor_auth_desc")}</Form.Row>

            <Form.Row className="mt-3 d-flex align-items-center">
              <div>
                <ToggleButton
                  onClick={() => {
                    const multiFactorAuth = user.multiFactorAuth === "Y" ? "N" : "Y"; // toggle the value
                    const multiFactorAuthType = user.multiFactorAuth === "Y" ? "N" : "E"; // toggle the value
                    const locale = user.language;
                    const timezone = user.timezone;

                    this.props.dispatch(
                      requestChangeMFAStart({
                        multiFactorAuth,
                        multiFactorAuthType,
                        locale,
                        timezone
                      })
                    );
                  }}
                  active={user.multiFactorAuth === "Y"}
                  size="xs"
                  style={{ marginTop: "-2px" }}
                />
              </div>
              <div>{t("user_details.email_auth")}</div>
              <div className="ml-2">{mfaLoading && <Loading />}</div>
            </Form.Row>
          </div>
        }
      </Form>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user
  };
};
UserDetailsForm = withT(
  connect(mapStateToProps)(UserDetailsForm),
  "user.profile"
);

export { UserDetailsForm };
